import { useEffect, useState } from "react";

export const SplashScreen = ({ children }: { children: React.ReactNode }) => {
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => setLoading(false), 2000);
		return () => clearTimeout(timer);
	}, []);

	if (loading) {
		return (
			<div
				style={{ backgroundColor: "#ffffff" }}
				className="d-flex flex-column justify-content-center align-items-center vh-100 text-white"
			>
				<img src="/logo512.png" alt="Logo" style={{ width: 100, height: 100, marginBottom: 20 }} />
				<h1 style={{ color: "#bc231e" }}>found.center</h1>
				{/* <h4 className="text-muted">Mobile Agent</h4> */}
			</div>
		);
	}

	return <>{children}</>;
};
